// extracted by mini-css-extract-plugin
module.exports = {"content":"DashboardView__content","loaderContainer":"DashboardView__loaderContainer","button":"DashboardView__button"};